import QuickStats from './QuickStats';

export default QuickStats;
